import { useBoolean } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Providers from '../../../../components/dashboard_components/Providers';
import { CUSTOM } from '../../../../constants/constants';
import hospitalDashboardRepository from '../../../../repositories/HospitalRepository';
import { dateFormat } from '../../../../utils/common.utils';

function HProvider({
  defaultStartDate,
  defaultEndDate,
  startDate,
  endDate,
  filter,
}) {
  const { hospitalId } = useParams();
  const [isFetching, ifState] = useBoolean(false);
  const [providerData, setProviderData] = useState(null);
  const [search, setSearch] = React.useState('');
  const [ordering, setOrdering] = React.useState('');

  const selectedDates = JSON.parse(
    window.localStorage.getItem('customDateFilter')
  );

  const setCustomDates = filterParams => {
    for (const prop in selectedDates) {
      filterParams[prop] = dateFormat(
        new Date(selectedDates[prop]),
        'yyyy-MM-dd'
      );
    }
  };



  const fetchHospitalProvider = async () => {
    try {
      ifState.on();
      const filterParams = {};
      filterParams.filter = filter.toLowerCase();

      if (filter === CUSTOM.toLowerCase()) {
        setCustomDates(filterParams);
        delete filterParams.filter;
      }

      if(search){
        filterParams['search']=search
      }

      filterParams.hospital_id = hospitalId;

      const response = await hospitalDashboardRepository.getHOspitalprovider(
        filterParams
      );
      return setProviderData(response);
    } catch (error) {
      setProviderData(null);
    } finally {
      ifState.off();
    }
  };

  React.useEffect(() => {
    fetchHospitalProvider();
    // eslint-disable-next-line
  }, [defaultStartDate, defaultEndDate, ordering, filter]);

  const uiStartDate = dateFormat(defaultStartDate, 'MM/dd/yyyy');
  const uiEndDate = dateFormat(defaultEndDate, 'MM/dd/yyyy');

  return (
    <Providers
      search={search}
      defaultStartDate={uiStartDate}
      defaultEndDate={uiEndDate}
      setSearch={setSearch}
      fetchHospitalProvider={fetchHospitalProvider}
      isFetching={isFetching}
      providerData={providerData}
      setOrdering={setOrdering}
      filter={filter}
    />
  );
}

export default HProvider;
